import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './DispatcherButton.module.scss'

export const DispatcherButton = () => {
  const navigate = useNavigate()

  const handleDispatcherClick = useCallback(() => {
    navigate('/shop')
  }, [navigate])

  return (
    <div
      className={styles.dispatcherButtonButton}
      onClick={handleDispatcherClick}
    >
      <img src="/assets/home/StoreIcon.svg" alt="StoreIcon" className={styles.icon} />
    </div>
  )
}
